import { defineStore } from 'pinia'
import { Media } from '@/classes'

export default defineStore('popin', () => {
  const medias: Ref<Media[]> = ref([])
  const initialIndex = ref(0)
  const size = ref('')
  const popinZIndex = ref(300)

  const displayMedias = (
    m: Media[],
    index?: number,
    s?: '' | 'm' | 's' | 'l'
  ) => {
    medias.value = m
    initialIndex.value = index ?? 0
    size.value = s ? s : ''
  }

  const hideMedias = () => {
    medias.value = []
    initialIndex.value = 0
    size.value = ''
  }

  return {
    size,
    medias,
    initialIndex,
    displayMedias,
    popinZIndex,
    hideMedias
	}
})
